// export const tableConfig = {
//   t_7a: {
//     fieldRules: {
//       hiddenFields: ["id"],

//       DIVISION: {
//         disabled: true, /// if you want the field is disabled
//       },

//       A_MONTH: {
//         /// if user filled  the f_year the he can fil te A_month
//         disabled: (row) => !row.F_YEAR,
//         //         sub_code: {   /// example of multiple dependencies
//         //   disabled: (row) =>
//         //     !row.main_code ||
//         //     !row.department ||
//         //     row.status === "Closed",
//         required: true, /// if the field is required
//       },

//       F_YEAR: {
//         required: true, /// if the field is required
//       },
//     },

//     fieldOptions: {
//       F_YEAR: [
//         { label: "2025", value: "2025" },
//         { label: "2026", value: "2026" },
//       ],
//     },
//     // ///////////////////////////////////////////////////////////////////////////////
//     // dependent select
//     // //////////////////////////////////////////////////////////////////////////////
//     dependencies: {
//       // STATIC DEPENDENCY
//       A_MONTH: {
//         source: "static",

//         dependsOn: ["F_YEAR"], // unless you will the dependsOn nex option will be disabled

//         options: {
//           2025: [
//             { label: "April", value: "apr" },
//             { label: "May", value: "may" },
//           ],

//           2026: [
//             { label: "June", value: "jun" },
//             { label: "July", value: "jul" },
//           ],
//         },
//       },

//       // API DEPENDENCY
//       DIVISION: {
//         source: "api",

//         dependsOn: ["ZONE"],

//         api: {
//           url: "/api/division-options",
//           method: "GET",
//         },
//       },

//       SECTION: {
//         source: "api",

//         dependsOn: ["DIVISION"],

//         api: {
//           url: "/api/section-options",
//           method: "GET",
//         },
//       },

//       FROM_STN: {
//         source: "api",

//         dependsOn: ["DIVISION", "SECTION"],

//         api: {
//           url: "/api/station-options",
//           method: "GET",
//         },
//       },
//     },
//   },
// };
// // /////////////////////////////////expecting api output
// // [
// //   {
// //     label: "JBP",
// //     value: "JABALPUR",

// //     rawData: {
// //       ZONE: "JBP",
// //       DIVISION: "WCR",
// //       STATION_CODE: "JBP",
// //       STATION_NAME: "jabalpur"
// //     }
// //   }
// // ]
export const tableConfig = {
  t_7a: {
    columnOrder: ["F_YEAR", "A_MONTH", "DIVISION", "FROM_STN", "TO_STN"],
    rowSort: [
      {
        field: "siding",
        order: [
          "JQSG",
          "BCSW",
          "UCLM",
          "MYR / KJS",
          "RCPB",
          "DDSG",
          "UCLT",
          "PCIH",
        ],
      },
      {
        field: "LINE",
        order: ["UP", "DOWN"],
      },
    ],

    fieldRules: {
      hiddenFields: ["id"],

      DIVISION: {
        // disabled: true,
      },

      A_MONTH: {
        disabled: (row) => !row.F_YEAR,
        required: true,
      },

      F_YEAR: {
        required: true,
      },
    },

    // =====================================
    // STATIC OPTIONS
    // =====================================
    fieldOptions: {
      F_YEAR: [
        { label: "2025", value: "2025" },
        { label: "2026", value: "2026" },
      ],
    },

    // =====================================
    // DEPENDENT FIELDS
    // =====================================
    dependencies: {
      // ---------------------------------
      // STATIC DEPENDENCY
      // ---------------------------------
      A_MONTH: {
        type: "static",

        dependsOn: ["F_YEAR"],

        options: {
          2025: [
            { label: "April", value: "apr" },
            { label: "May", value: "may" },
          ],

          2026: [
            { label: "June", value: "jun" },
            { label: "July", value: "jul" },
          ],
        },
      },

      // ---------------------------------
      // MASTER DATA DEPENDENCY
      // ---------------------------------
      DIVISION: {
        type: "masterData",
        multipleOption: false,
        source: "divisions",

        dependsOn: ["ZONE"],

        optionLabel: "DIVISION",
        optionValue: "DIVISION",
      },

      FROM_STN: {
        type: "masterData",
        disabled: true,
        source: "stations",

        dependsOn: ["ZONE", "DIVISION", "SECTION"],

        optionLabel: "STATION_NAME",
        optionValue: "STATION_CODE",

        // future feature
        autoFill: {
          STATION_NAME: "STATION_NAME",
          STATION_CODE: "STATION_CODE",
        },
      },
    },

    // /////////////////////////////////////////////////////////////////////
    //compute
    ////////////////////////////////////////////////////////////////////////

    computedFields: {
      ACT_WEIGHT: {
        expression: "[CH_WEIGHT] - [WAGON]",
        type: "number",
      },
    },

    // ///////////////////////////////////////////////////////////////////
    // ///////////////////////////////////////////////////////////////////
  },

  t_indent_hdr: {
    fieldRules: {
      siding: {
        disabled: true,
      },
      hiddenFields: ["id"],
      report_date: {
        required: true,
      },
    },
    fixedRows: {
      field: "siding",
      values: [
        "JQSG",
        "BCSW",
        "UCLM",
        "MYR / KJS",
        "RCPB",
        "DDSG",
        "UCLT",
        "PCIH",
      ],
    },
    rowSort: [
      {
        field: "siding",
        order: [
          "JQSG",
          "BCSW",
          "UCLM",
          "MYR / KJS",
          "RCPB",
          "DDSG",
          "UCLT",
          "PCIH",
        ],
      },
    ],
  },
  m_commodity: {
    fieldRules: {
      hiddenFields: ["id", "dt"],
    },
  },
  m_wagons: {
    fieldRules: {
      hiddenFields: ["id", "dt"],
    },
  },
  m_stations_sidings_useable: {
    fieldRules: {
      hiddenFields: ["id", "dt"],
    },
  },
};
